import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxPopupModule } from 'devextreme-angular';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { VimeoVideoComponent } from './vimeo-video.component';
import { VimeoVideoSharePopupComponent } from './components/vimeo-video-share-popup/vimeo-video-share-popup.component';

@NgModule({
  declarations: [VimeoVideoComponent],
  exports: [VimeoVideoComponent],
  imports: [CommonModule, SharedModule, DxPopupModule, VimeoVideoSharePopupComponent],
})
export class VimeoVideoModule {}
